// DO NOT EXPORT THIS FILE
// use getConfig instead

export default {
  // place config override for prod env here
  isCognitoEnabled: true,
  host: {
    bus: 'https://api-trip.txt.traveloka.com',
    hcn: 'https://api.hcn.traveloka.com',
  },
  amplify: {
    Auth: {
      region: 'ap-southeast-1',
      userPoolId: 'ap-southeast-1_cGZbO3aWo',
      userPoolWebClientId: '2gn3a7e38flp6e2av1tj7mvs2m',

      oauth: {
        domain: 'https://txt.auth.ap-southeast-1.amazoncognito.com/',
        scope: ['email', 'profile', 'openid'],
        redirectSignIn: 'http://localhost:3000/',
        redirectSignOut: 'http://localhost:3000/',
        responseType: 'code',
      },
    },
  },
  auth: {
    domain: 'tvlk.auth0.com',
    clientID: 'DGzPtkNmCE45w3wsQb8emXKqUxnqtOjU',
    redirectUri: '/callback',
    audience: 'https://tvlk/txt',
    responseType: 'token id_token',
    scope: 'openid',
  },
};
